export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11649.173dc01e.jpg";